export const layerStyles = {};
